import { useMemo } from "react";
import { useIntl } from "react-intl";

import Checkbox from "components/v2/Checkbox/Checkbox";
import testIds from "constants/testIds";
import FormSectionLabel from "pages/shipper/RequestFormV2/components/FormSectionLabel/FormSectionLabel";
import { useConsigneeSync } from "@RequestFormV2/sections/Schedule/hooks/useConsigneeSync";
import {
  getConsigneeSharedAddressFieldPaths,
  getConsigneeSharedContactFieldPaths,
} from "@RequestFormV2/sections/Schedule/utils/consigneeFieldPaths";
import SharedAddressSection from "@RequestFormV2/sections/Schedule/components/shared/AddressSection";
import SharedContactSection from "@RequestFormV2/sections/Schedule/components/shared/ContactSection";

export default function ConsigneeSection() {
  const intl = useIntl();
  const sync = useConsigneeSync();

  const addressFieldPaths = useMemo(() => getConsigneeSharedAddressFieldPaths(), []);
  const contactFieldPaths = useMemo(() => getConsigneeSharedContactFieldPaths(), []);

  return (
    <div className="rfv2-form-section rfv2-schedule-consignee" data-testid={testIds.REQUEST_FORM_SCHEDULE_CONSIGNEE_SECTION}>
      <FormSectionLabel
        label={intl.formatMessage({
          id: "new-request.schedule.consignee",
          defaultMessage: "Consignee",
        })}
      />

      <div className="rfv2-form-section__content rfv2-schedule-consignee__fields">
        <Checkbox
          checked={sync.sameAsDelivery}
          onChange={(e) => sync.handleSameAsDeliveryChange(e.target.checked)}
          label={intl.formatMessage({
            id: "new-request.schedule.sameAsDeliveryAddressContact",
            defaultMessage: "Same as delivery address & delivery contact",
          })}
        />

        <div className="rfv2-form-section rfv2-form-section--nested">
          <SharedAddressSection
            fieldPaths={addressFieldPaths}
            contactFieldPaths={contactFieldPaths}
            fieldsDisabled={sync.fieldsDisabled}
            isRequired
            testIdPrefix={testIds.REQUEST_FORM_SCHEDULE_CONSIGNEE_ADDRESS_TYPE}
            portTestId={testIds.REQUEST_FORM_SCHEDULE_CONSIGNEE_PORT_SELECT}
            addressSearchTestId={testIds.REQUEST_FORM_SCHEDULE_CONSIGNEE_ADDRESS_SELECT}
            addressSearchPlaceholder={intl.formatMessage({
              id: "new-request.schedule.multistop.searchAddress",
              defaultMessage: "Select address",
            })}
          />
        </div>

        <SharedContactSection
          fieldPaths={contactFieldPaths}
          fieldsDisabled={sync.fieldsDisabled}
          isRequired={false}
          contactNameTestId={testIds.REQUEST_FORM_SCHEDULE_CONSIGNEE_CONTACT_NAME}
          contactPhoneTestId={testIds.REQUEST_FORM_SCHEDULE_CONSIGNEE_CONTACT_PHONE}
          contactEmailTestId={testIds.REQUEST_FORM_SCHEDULE_CONSIGNEE_CONTACT_EMAIL}
        />
      </div>
    </div>
  );
}
